import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { DictionaryPapIndexDataService, DictionaryPapIndexDialogData } from 'src/app/shared';
import { ErrorDialogComponent } from 'src/components/shared/error-dialog/error-dialog.component';


@Component({
  standalone: false,
  selector: 'app-add-new-pap-index-dialog',
  templateUrl: './add-new-pap-index-dialog.component.html',
  styleUrl: './add-new-pap-index-dialog.component.scss',
})
export class AddNewPapIndexDialogComponent implements OnInit {
  papIndexForm: FormGroup;
  errorMessage?: string;

  data: DictionaryPapIndexDialogData = {
    currencies: [],
    unitNames: []
  };

  constructor(
    public dialogRef: MatDialogRef<AddNewPapIndexDialogComponent>,
    private dataService: DictionaryPapIndexDataService,
    private dialog: MatDialog
  ) {
    this.papIndexForm = new FormGroup({
      indexName: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('^[A-Z0-9/_ ]*$'),
        ],
      }),
      dateFrom: new FormControl('', Validators.required),
      indexValue: new FormControl('', {
        validators: [
          Validators.required,
          Validators.pattern('^[0-9]+([.][0-9]{1,2})?$'),
          Validators.maxLength(10),
        ],
      }),
      currency: new FormControl('', Validators.required),
      unit: new FormControl('', Validators.required)
    })
  }

  ngOnInit() {
    this.loadAuxiliaryData();

    this.papIndexForm.controls.indexValue.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: number) =>
        this.papIndexForm.controls.indexValue.setValue(
          value.toString().replace(',', '.')
        )
      );
  }

  private loadAuxiliaryData(): void {
    this.dataService
      .getAuxiliaryData()
      .subscribe(response =>
        this.data = response
      )
  }

  transformToUppercase(field: string) {
    let currentValue = this.papIndexForm.get(field)?.value;
    if (currentValue) {
      this.papIndexForm.get(field)?.setValue(currentValue.toUpperCase(),
        { emitEvent: false });
    }
  }

  addNewIndex() {
    const request = {
      id: undefined,
      indexName: this.papIndexForm.controls.indexName.value,
      validSince: this.papIndexForm.controls.dateFrom.value?.toISODate(),
      indexValue: this.papIndexForm.controls.indexValue.value,
      uoM: this.papIndexForm.controls.currency.value +
        '/' + this.papIndexForm.controls.unit.value,
    };
    this.dataService.add(request).subscribe({
      next: () => {
        this.dialogRef.close(this.papIndexForm.value);
      },
      error: (error) => {
        if (error || this.papIndexForm.invalid) {
          console.error(error.error.Message);
          this.errorMessage = error.error.Message;
          this.handleError(error);
        }
      },
    });
  }

  private handleError(error: any) {
    this.dialog.open(ErrorDialogComponent, {
      data: { message: error.error.Message },
    });
  }
}
